import React from 'react';
import {Link} from 'react-router-dom';

var arr = ["Getting engines ready...", "Organizing missions...", "Preparing for launch..."]

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        emailValue: '',
        fNameValue: '',
        lNameValue: '',
    };
  }

 render() {
    return (
      <div>
        <div id="landing">
            <div id="border-box">
                <div id="title">
                    <img id="inertiaLogo" src={require("./assets/images/inertia-temp.png")} alt="inertia-logo"/>
                    <div className="typewriter">
                      <p id="landing-text" style={{textAlign: 'center'}} data-period="2000">Re-imagining STEM.</p>
                    </div>

               <div id="register-contact">
                 <div class="col-md-10 col-lg-8 mx-auto text-center">
                   <form action="https://nyc.us1.list-manage.com/subscribe/post?u=a5aa3643fc82c9d63b1718912&amp;id=8dd23f6ac1" method="POST" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="form-inline d-flex validate" target="_blank" novalidate>
                    <input type="hidden" name="u" value="eb05e4f830c2a04be30171b01"/>
                    <input type="hidden" name="id" value="8281a64779"/>
                    <label style={{display: 'contents'}}>
                        <input
                            type="email"
                            name="EMAIL"
                            id="MERGE0"
                            value={this.state.emailValue}
                            onChange={ (e)=>{this.setState({emailValue: e.target.value});} }
                            autoCapitalize="off"
                            autoCorrect="off"
                            placeholder="Enter email address.."
                            style={{color: "black"}}
                            class="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0"
                         />
                    </label>
                    <button type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="submit-theme btn-primary btn mx-auto" style={{color: "darkgreen", backgroundColor: "#1ae8a0", border: "#31ffa4"}}>Subscribe</button>
                    <div style={{position: 'absolute', left: '-5000px'}} aria-hidden='true' aria-label="Please leave the following three fields empty">
                        <label htmlFor="b_email">Email: </label>
                        <input type="email" name="b_email" tabIndex="-1" value="" placeholder="youremail@gmail.com" id="b_email"/>
                    </div>
                </form>
              </div>

                </div>
             </div>

            <div id="hands">
                <div className="first handRow below">
                </div>
                <div className="second handRow">
                    <img id="orangeHand" className="hand" src={require("./assets/images/web_hand1.png")} />
                    <img id="redHand" className="hand" src={require("./assets/images/web_hand4.png")} />
                </div>
             </div>
        </div>
      </div>
    </div>
    )
  }
}

export default Landing;
